import * as React from 'react'
import {Popover as PopoverPrimitive} from 'radix-ui'

import {cn} from '@/lib/utils'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger

/** Dentro de un diálogo modal, el nodo del `DialogContent` tomado con ref de callback (un `useRef` llega `null`):
 * portado al body, Escape cierra el diálogo y el foco se escapa. No es automático: recortaría los combobox anchos. */
type ContenedorProp = {container?: React.ComponentProps<typeof PopoverPrimitive.Portal>['container']}

function PopoverContent({
  className,
  align = 'start',
  sideOffset = 4,
  container,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content> & ContenedorProp) {
  return (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          // 28rem covers the widest trigger (CIIU combobox, ~25rem); a caller's `w-*` coexists with this `max-w-*`.
          'z-50 max-w-[min(28rem,var(--radix-popover-content-available-width,28rem))] overflow-x-hidden rounded-xl border border-border bg-popover text-popover-foreground shadow-[var(--shadow-pop)] outline-none break-words',
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
}

export {Popover, PopoverContent, PopoverTrigger}
